module.exports = __webpack_public_path__ + "assets/img/20220509-2.335d15f1.png";